import { Role } from '@auth/enums/role.enum';
import { hasRoleListGuard } from '@auth/guards/has-role-list.guard';
import { hasRoleGuard } from '@auth/guards/has-role.guard';
import { hasSelectedRoleGuard } from '@auth/guards/has-selected-role.guard';
import { isAuthGuard } from '@auth/guards/is-auth.guard';
import { Url } from '@core/enums/url.enum';
import { AppRoutes } from '@core/interfaces/app-routes.interface';
import { chainCanActivateFns } from '@core/utils/chain-can-active-fns.util';
import { lastUrlSegment } from '@core/utils/last-url-segment.util';

import { ADMIN_ROUTES } from './admin.routes';
import { AUTH_ROUTES } from './auth.routes';
import { CONTRACTOR_ROUTES } from './contractor.routes';

export const APP_ROUTES: AppRoutes = [
  {
    path: lastUrlSegment(Url.Login),
    children: AUTH_ROUTES,
  },
  {
    path: lastUrlSegment(Url.Dashboard),
    canActivate: [chainCanActivateFns(isAuthGuard, hasRoleListGuard, hasSelectedRoleGuard)],
    loadComponent: () => import('@shared/components/drawer-menu/drawer-menu.component'),
    children: [
      {
        path: lastUrlSegment(Url.Admin),
        canActivate: [hasRoleGuard],
        data: { roles: [Role.Admin] },
        children: ADMIN_ROUTES,
      },
      {
        path: lastUrlSegment(Url.Contractor),
        canActivate: [hasRoleGuard],
        data: { roles: [Role.FullContractor] },
        children: CONTRACTOR_ROUTES,
      },
    ],
  },
  {
    path: '**',
    redirectTo: lastUrlSegment(Url.Login),
  },
];
